import "./styles/global.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./components/layouts/Layout";
import { ScreenActivity } from "./components/screenActivity"
import { Auth as UserContext } from "./contexts/ridersUserContext";
import { LanguageContextProvider } from "./contexts/languageContext";
import { NotificationProvider } from "./contexts/notifications";
import { RedirectPage } from "./pages/redirectPage";
import RouteWithIntl from "./components/routeWithIntl";
import RabbitMQSender from "./utils/MQSender";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RedirectPage />} />
        <Route
          path="/multilayout/:token"
          element={
            <UserContext>
              <LanguageContextProvider>
                <RouteWithIntl>
                  <NotificationProvider>
                    <Layout />
                    <ScreenActivity />
                  </NotificationProvider>
                </RouteWithIntl>
              </LanguageContextProvider>
            </UserContext>
          }
        />
        <Route path="/amq-sender" element={<RabbitMQSender />} />
        <Route
          path="*"
          element={
            <RouteWithIntl>
              <Layout />
            </RouteWithIntl>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
